import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { Footer, GradientHero, SEO, breadcrumbSchema } from '@coupling/ui';
import { getBlogPosts } from '../utils/blog';
import Header from '../components/Header';
import { seoConfig } from '../config/seo';

const Blog: React.FC = () => {
    const posts = useMemo(() => getBlogPosts(), []);

    return (
        <div className="min-h-screen bg-white font-sans text-neutral-900">
            <SEO
                title={`Blog - ${seoConfig.siteName}`}
                description="News, stories, and updates from the WNC merchant network."
                canonical={`${seoConfig.siteUrl}/blog`}
                ogImage={seoConfig.defaultOgImage}
                ogUrl={`${seoConfig.siteUrl}/blog`}
                jsonLd={breadcrumbSchema([
                    { name: 'Home', url: seoConfig.siteUrl },
                    { name: 'Blog', url: `${seoConfig.siteUrl}/blog` },
                ])}
            />
            <Header />

            <GradientHero
                title="Coupling WNC Blog"
                description="News, stories, and updates from the WNC merchant network."
            />

            <main className="max-w-4xl mx-auto px-4 py-16 sm:px-6 lg:px-8">
                <div className="grid gap-8 md:grid-cols-2">
                    {posts.map((post) => (
                        <Link
                            key={post.slug}
                            to={`/blog/${post.slug}`}
                            className="flex flex-col overflow-hidden rounded-lg shadow-md hover:shadow-xl transition-shadow duration-300 bg-white border border-neutral-200"
                        >
                            <div className="flex-1 p-6 flex flex-col justify-between">
                                <div className="flex-1">
                                    <p className="text-sm font-medium text-brand-primary">
                                        Announcement
                                    </p>
                                    <div className="block mt-2">
                                        <p className="text-xl font-semibold text-neutral-900">
                                            {post.title}
                                        </p>
                                        <p className="mt-3 text-base text-neutral-600 line-clamp-3">
                                            {post.description}
                                        </p>
                                    </div>
                                </div>
                                <div className="mt-6 flex items-center">
                                    <div>
                                        <p className="text-sm font-medium text-neutral-900">
                                            {post.author}
                                        </p>
                                        <div className="flex space-x-1 text-sm text-neutral-500">
                                            <time dateTime={post.date}>{post.date}</time>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Link>
                    ))}
                </div>
            </main>

            <Footer />
        </div>
    );
};

export default Blog;
